<template>
  <article class="text-white layout-landing-us">
    <Xtop class="pc-only" />
    <sound-btn
      class="pc-only fixed bottom-[100px] right-[36px] w-[40px] h-[40px] rounded-[40px] z-[200] cursor-pointer flex-center muted-btn"
      :muted="muted"
      @click="toggleMuted"
    />
    <div
      ref="container"
      class="pc-container w-screen overflow-scroll relative z-[10]"
      :style="{
        backgroundImage: `url(${transformImage(
          getFeUrl(
            `/youyan-platform/png/${
              getEnv('area') === 'CN' ? 'white' : 'black2'
            }.png`
          )
        )})`,
      }"
    >
      <slot />
    </div>
  </article>
</template>
<script lang="ts" setup>
import Scrollbar from 'smooth-scrollbar'
import Xtop from '../components/xTop/index.vue'
import SoundBtn from '@/features/landing/sound-btn/index.vue'
import { useMutedProvider } from '~/hooks/useVideoActionInScroll'
const container = ref<HTMLElement>()
const { muted, toggleMuted } = useMutedProvider()

const { isMobile } = useDevice()

onMounted(() => {
  if (container.value && !isMobile) {
    Scrollbar.init(container.value, { damping: 0.05 })
  }
})

useHead({
  meta: [
    {
      property: 'og:image',
      content: getFeUrl('/youyan-platform/png/homepage_landing.png'),
    },
  ],
})
</script>
<style lang="scss">
.layout-landing-us {
  background: #000;
  .pc-container {
    height: calc(100vh);

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .container {
    min-width: rem(1200);
    padding-left: rem(20);
    padding-right: rem(20);
  }

  .video_cover {
    video {
      object-fit: cover;
    }

    .object-contain {
      video {
        object-fit: contain;
      }
    }
  }
}
</style>
